const TopicTwo = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Stock Market Trading Conditions</h1>
        <p>
          Competitive spreads, flexible leverage, and transparent pricing,
          designed to help you trade smarter and faster.
        </p>
      </div>
    </div>
  );
};

export default TopicTwo;
